import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import Hero from './components/hero';
import Footer from "./components/footer";
import "./styles/services.css";

export default class Services extends Component {
  render() {
    return (
      <div>
        <Hero
  			title="What We Do"
  			backgroundImage="images/services-back.jpg"
  			height="half"
  		  />
        <div className="large-padding">
          <div className="medium-max-width-container white-background">
            <div className="row mobile-reverse">
              <div className="small-12 medium-6 row">
                <div className="services-page-text center-position">
                  <h4>{'Design'}</h4>
                  <p>{'Great design is not just about how it looks, but how it performs. Our top priority is to provide our clients with creative solutions that are both effective and unique. '}</p>
                  <NavLink className="button black-background white" exact to="/contact">{'Get Started'}</NavLink>
                </div>
              </div>
              <div className="small-12 medium-6">
                <img className="full-width" alt="" src="images/services-design.png" />
              </div>
            </div>
            <div className="row" >
              <div className="small-12 medium-6">
                <img className="full-width" alt="" src="images/services-code.png" />
              </div>
              <div className="small-12 medium-6 row">
                <div className="services-page-text center-position">
                  <h4>{"Web & Digital"}</h4>
                  <p>{'A website is a 24/7 visual representation of a company. We integrate cutting-edge technology and captivating design to create personalized experiences for mobile and desktop alike.'}</p>
                  <NavLink className="button black-background white" exact to="/contact">{'Get Started'}</NavLink>
                </div>
              </div>
            </div>
            <div className="row mobile-reverse">
              <div className="small-12 medium-6 row">
                <div className="services-page-text center-position">
                  <h4>{'Photography & Videography'}</h4>
                  <p>{'Strong photography and videography can tell a story that sets a brand apart from its competitors. By utilizing photography and videography, we are able to highlight a brand\'s craftsmanship and visually define their message in a way that is impossible not to notice. '}</p>
                  <NavLink className="button black-background white" exact to="/contact">{'Get Started'}</NavLink>
                </div>
              </div>
              <div className="small-12 medium-6">
                <img className="full-width" alt="" src="images/services-photography.png" />
              </div>
            </div>
            <div className="row">
              <div className="small-12 medium-6">
                <img className="full-width" alt="" src={'images/services-branding.png'} />
              </div>
              <div className="small-12 medium-6 row">
                <div className="services-page-text center-position">
                  <h4>{'Brand & Identity'}</h4>
                  <p>{'The success of the brands that we service is as important to us as our own. We take great pride in creating logos and brand identities that fully capture the attention of the audience it aims to serve.'}</p>
                  <NavLink className="button black-background white" exact to="/contact">{'Get Started'}</NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/services.js